import type * as React from 'react';

export function GridTexture(props: React.ComponentPropsWithoutRef<'div'>) {
    return (
        <div
            {...props}
            style={{
                backgroundSize: '20px 20px',
                backgroundPosition: '-1px -1px',
                boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.15)',
                backgroundImage:
                    'linear-gradient(to right, rgba(0, 0, 0, 0.15) 1px, transparent 1px), linear-gradient(to bottom, rgba(0, 0, 0, 0.15) 1px, transparent 1px)',
                ...props.style,
            }}
        />
    );
}
